import { MRT_ColumnDef, createMRTColumnHelper } from "material-react-table";
import { useTranslation } from "react-i18next";
import { GridText } from "src/components/Grid/GridText";
import { Permission } from "src/api/client-api/permissions/useGetAllPermissions";
import { StringFilter } from "src/components/Grid/filters/StringFilter";

export type PermissionGridColumns = MRT_ColumnDef<Permission, any>[];

export const usePermissionColumns = (p0: Permission[], gridKey: string): PermissionGridColumns => {
    const { t } = useTranslation();

    const columnHelper = createMRTColumnHelper<Permission>();
    const mrt_columns: PermissionGridColumns = [];

    const noValue = "-";
    mrt_columns.push(
        columnHelper.accessor((row) => row.identifier ?? noValue, {
            id: "identifier",
            header: t("permission.identifier", "Identifier"),
            Cell: (value) => <GridText value={value.renderedCellValue}></GridText>,
            grow: false,

            Filter: (mrtProps) => {
                return <StringFilter mrtProps={mrtProps} />;
            },
            enableSorting: true,
            enableColumnFilter: true,
        }),
    );

    mrt_columns.push(
        columnHelper.accessor((row) => row.object ?? noValue, {
            id: "object",
            header: t("permission.object", "Object"),
            Cell: (value) => <GridText value={value.renderedCellValue} />,

            Filter: (mrtProps) => {
                return <StringFilter mrtProps={mrtProps} />;
            },
            enableSorting: true,
            enableColumnFilter: true,
        }),
    );

    mrt_columns.push(
        columnHelper.accessor((row) => row.slug ?? noValue, {
            id: "slug",
            header: t("permission.slug", "Action"),
            Cell: (value) => <GridText value={value.renderedCellValue} />,

            Filter: (mrtProps) => {
                return <StringFilter mrtProps={mrtProps} />;
            },
            enableSorting: true,
            enableColumnFilter: true,
        }),
    );

    mrt_columns.push(
        columnHelper.accessor((row) => row.extra ?? noValue, {
            id: "extra",
            header: t("permission.extra", "Extra expression"),
            Cell: (value) => <GridText value={value.renderedCellValue} />,

            Filter: (mrtProps) => {
                return <StringFilter mrtProps={mrtProps} />;
            },
            enableSorting: true,
            enableColumnFilter: true,
        }),
    );

    return mrt_columns;
};
